







































import Vue from 'vue'
import CreateCheckForm from '@/components/CreateCheck/CreateCheckForm.vue'
import Tabs from '@/components/Tabs/Tabs.vue'
import { mapMutations } from 'vuex'
import User from '../User/User.vue'

export default Vue.extend({
  name: 'QueryModal',
  components: {
    CreateCheckForm,
    Tabs,
    User
  },
  props: {
    dialog: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      dialogStatus: false
    }
  },
  methods: {
    ...mapMutations(['updateModalStatus'])
  },
  model: {
    prop: 'dialog',
    event: 'changeState'
  },
  watch: {
    dialogStatus () {
      this.$emit('changeState', this.dialogStatus)
      this.updateModalStatus(this.dialogStatus)
    },
    dialog () {
      this.dialogStatus = this.dialog
    },
    '$route.params.id' () {
      this.dialogStatus = false
    }
  }
})
